import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NotificationsService } from '../../services/notifications.service';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { catchError, map, of, switchMap } from 'rxjs';
import * as actions from './notifications.actions';
import { EffectFactory } from '../../../shared/store/common/effect.factory';

@Injectable()
export class NotificationEffects {
    private actions$ = inject(Actions);
    private api = inject(NotificationsService);
    private store = inject(Store);
    private router = inject(Router);


    factory = new EffectFactory(this.actions$, actions, this.api).create();

    getNotifications$ = this.factory.getNotifications;

    deleteNotification$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.deleteNotification),
            switchMap(({ input }) =>
                this.api.deleteNotification(input.id).pipe(
                    map(() => actions.deleteNotificationSuccess({ notification: { ok: true }})),
                    catchError(() =>
                        of(actions.deleteNotificationFailure({ notification: null })),
                    ),
                ),
            ),
        ),
    );

    readNotification$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.readNotification),
            switchMap(({ input }) =>
                this.api.updateNotification(input).pipe(
                    map((read) =>
                        actions.readNotificationSuccess({ read }),
                    ),
                    catchError(() =>
                        of(actions.readNotificationFailure({ read: null })),
                    ),
                ),
            ),
        ),
    );

    receiveNotification$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.receiveNotification),
            switchMap(({ user }) =>
                this.api
                    .getSubscription(user)
                    .pipe(
                        map((notification) =>
                            actions.receiveNotificationSuccess({ notification }),
                        ),
                    ),
            ),
        ),
    );

}
